<template>
    <div style="max-width: 1200px;" class="mx-auto">
        <div class="my-4">Costs associated with conventional mortgages are typically lower than FHA reverse mortgage costs. Each
            borrower must decide if the flexible features of the FHA reverse mortgage justify the cost. Below
            are cost estimates for your FHA reverse mortgage scenario.
        </div>

        <v-simple-table>
            <thead>
                <tr>
                    <th class="text-left"></th>
                    <th class="text-left">Estimated Reverse Mortgage Fees</th>
                    <th class="text-left">Notes</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>FHA Insurance</td>
                    <td>{{ formatMoney(this.values.insurancePremiumFHA) }}</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Origination Fee</td>
                    <td>{{ formatMoney(this.values.originationFee) }}</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Misc Closing Costs</td>
                    <td>{{ formatMoney(this.values.closingCosts) }}</td>
                    <td>Title Insurance, Appraisal, Escrow, Notary and other fees</td>
                </tr>
                <tr>
                    <td>Lender Credit</td>
                    <td>{{ formatMoney(this.values.lenderBrokerCredit) }}</td>
                    <td></td>
                </tr>
                <tr>
                    <td><strong>Total Financed Fees:</strong></td>
                    <td><strong>{{ formatMoney(
                        this.values.insurancePremiumFHA +
                        this.values.originationFee +
                        this.values.closingCosts +
                        this.values.lenderBrokerCredit ) }}</strong></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Out of Pocket fees usually paid by the borrower:</td>
                    <td>$150 to $200</td>
                    <td>3rd party suitability analysis, AKA Reverse Mortgage Counseling</td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import helpers from '../../helpers';

export default {
    methods: {
        formatMoney: helpers.formatMoney,
    },
    computed: {
        values() {
            const {
                insurancePremiumFHA,
                originationFee,
                closingCosts,
                lenderBrokerCredit,
            } = this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues;

            return {
                insurancePremiumFHA: insurancePremiumFHA.adjustable,
                originationFee: originationFee.adjustable,
                closingCosts: closingCosts.adjustable,
                lenderBrokerCredit: lenderBrokerCredit.adjustable,
            }
        }
    },
};
</script>
